import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import EnquiryAlertsSettings from "./pages/EnquiryAlertsSettings";
import LogsAnalytics from "./pages/LogsAnalytics";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import { useState } from "react";
import Subscriptions from "./pages/Subscriptions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Authorized from "./ApiMapper/protectedRouter"
import Unauthorized from "./ApiMapper/unathorized"
import NoSubscription from "./pages/NoSubscription";
import { SubscriptionRoute } from './components/SubscriptionRoute';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/no-subscription" element={<NoSubscription />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/account" element={<Account />} />
          <Route path="/subscriptions" element={<Subscriptions />} />

          {/* Subscription required routes */}
          <Route element={<SubscriptionRoute />}>
            <Route path="/enquiryalerts" element={<EnquiryAlertsSettings />} />
            <Route path="/logs" element={<LogsAnalytics />} />
          </Route>

          {/* Admin routes */}
          <Route path="/admin"
            element={
              <Authorized
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
              >
                <Admin />
              </Authorized>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
